import React from 'react';
import T from 'prop-types';
// components
import Icon from '../Icon/Icon';
// styles
import classnames from 'classnames/bind';
import styles from './Input.mod.css';

const cn = classnames.bind(styles);

const Input = ({
  className = '',
  wrapperClassName = '',
  autoComplete = 'off',
  type = 'text',
  invalid,
  centered,
  secondary,
  icon,
  color,
  value,
  ...otherProps
}) => (
  <div
    className={cn(styles.inputWrapper, wrapperClassName, {
      centered,
      secondary,
    })}
  >
    <input
      type={type}
      className={cn(styles.input, className, { invalid })}
      autoComplete={autoComplete}
      value={value || ''}
      {...otherProps}
    />
    <span
      className={styles.border}
      style={color ? { backgroundColor: color } : undefined}
    />
    {icon && <Icon type={icon} className={styles.icon} />}
  </div>
);

Input.propTypes = {
  className: T.string,
  wrapperClassName: T.string,
  type: T.oneOf(['text', 'tel', 'url', 'email', 'date', 'password', 'number']),
  autoComplete: T.oneOf(['on', 'off', 'cc-number', 'cc-csc', 'cc-exp']),
  icon: T.string,
  onChange: T.func,
  secondary: T.bool,
  invalid: T.oneOfType([T.bool, T.string]),
  centered: T.bool,
  color: T.string,
  value: T.string,
};

export default React.memo(Input);



// WEBPACK FOOTER //
// ./src/components/Input/Input.jsx